import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DevoteeService } from 'src/app/core/services';

@Component({
  selector: 'app-comment-dialog',
  templateUrl: './comment-dialog.component.html',
  styleUrls: ['./comment-dialog.component.scss']
})
export class CommentDialogComponent implements OnInit{
  constructor(
    private _devoteeService: DevoteeService, 
    private toaster: ToastrService,
    @Optional() private dialogRef?: MatDialogRef<CommentDialogComponent>,
    @Optional() private sheetRef?: MatBottomSheetRef<CommentDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: any,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public sheetData?: any,

  ){}

  comment = new FormControl('')
  role: any;
  status: string = 'SOLVED'
  isChecked: boolean=false;

  currentComment: string = '';
  isLoading: boolean = false;


  ngOnInit(): void {

    this.role = localStorage.getItem('role')
    
  }

  close(){
    this.dialogRef?.close(false)
    this.sheetRef?.dismiss(false)
 
  }

  // updateComment(){
  //   this.dialogRef.close({
  //     data: this.comment?.value,
  //   })
  // }
  Checked() {
    // this.isChecked=!this.isChecked
    console.log('checkboxvalue changed',this.isChecked)
  }
  updateComment() {
  console.log(this.isChecked)
    this.currentComment = this.comment?.value || ''
    // console.log(this.data._id, this.userId);
    // if(this.data?.status === 'RESPONSE PENDING' || this.data?.status === 'RESPONSE PENDING'){
    //   this.status = 'RESPONSE PENDING'
    // }


    if(!this.isChecked){
      this.status = this.data?.status;
    } else {
      this.status = 'RESOLVED'
    }

   
    if(this.currentComment.length >= 10){
      this.isLoading = true
    this._devoteeService.nivedanAssignTo(
      this.data?._id || this.sheetData?._id,
      this.status,
      {
        comment: this.currentComment,
      }
    )
    .subscribe({
      next: (res) => {
        this.isLoading= false;
        console.log('we are coming to res ??',res);
        this.dialogRef?.close(true)
        this.sheetRef?.dismiss(true)

      }, error: (err) => {
        this.isLoading= false;

        this.toaster.error(err.error);
      }
    });

  }else{
    this.toaster.error('Comment should be at least 10 characters');
   

    
  }
}
}
